import React, { Component } from 'react';
import axios from 'axios';
import { getMetaContent } from 'helpers/util';
// Special version of MatrixField for min_deposit that handles cents conversion
export default class MinDepositField extends Component {
  state = {
    editing: false,
    myValue: this.props.myValue,
    hoverEdit: false,
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.myValue !== this.props.myValue) {
      this.setState(({ myValue }) => ({ myValue: nextProps.myValue }));
    }
    return true;
  }

  toggleInput = e => {
    this.setState(({ editing }) => ({ editing: !editing }));
  };

  changeField = e => {
    e.persist();
    this.setState(({ myValue }) => ({ myValue: e.target.value }));
  };

  mouseHoverEdit = e => {
    this.setState(({ hoverEdit }) => ({ hoverEdit: true }));
  };

  mouseLeaveEdit = e => {
    this.setState(({ hoverEdit }) => ({ hoverEdit: false }));
  };

  onEditSubmit = e => {
    e.preventDefault();
    this.setState(({ editing }) => ({ editing: false }));
    if (this.state.myValue !== this.props.myValue) {
      // Use min_deposit_dollars instead of min_deposit
      axios
        .patch(`/matrix/listings/${this.props.listingId}/react.json`, {
          listing: { min_deposit_dollars: this.state.myValue },
          authenticity_token: getMetaContent('csrf-token'),
        })
        .then(res => {
          if (!res.ok) {
            console.log(res.statusText);
          }
        })
        .catch(err => console.log(err));
      
      // Update the parent component with the cents value for consistency
      // This matches how the backend stores it
      const centsValue = this.state.myValue ? parseInt(this.state.myValue, 10) * 100 : '';
      this.props.changeField(
        centsValue,
        this.props.editAttr.replace(/(\_\w)/g, text => text[1].toUpperCase()),
      );
    }
  };

  handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.onEditSubmit(e);
    }
  };

  render() {
    const { editing, hoverEdit, myValue } = this.state;
    const { edit, children, myClass } = this.props;

    return (
      <div
        onMouseEnter={this.mouseHoverEdit}
        onMouseLeave={this.mouseLeaveEdit}
        className={myClass}
      >
        {!editing ? children : ''}
        {hoverEdit && !editing && edit ? (
          <i
            onClick={this.toggleInput}
            className="nookons-edit nklyn-white matrix-listing-edit-button"
          />
        ) : (
          ''
        )}
        {editing ? (
          <form onSubmit={this.onEditSubmit}>
            <input
              className="edit-matrix-listing-input"
              type="text"
              value={myValue}
              onChange={this.changeField}
              onKeyDown={this.handleKeyDown}
            />
            <button
              className="button btn-rounded btn-1x btn-white-black submit-edit-matrix-button"
              type="submit"
              onClick={this.onEditSubmit}
            >
              Save
            </button>
          </form>
        ) : (
          ''
        )}
      </div>
    );
  }
} 